<template>
  <section
    v-if="hasReferenceContent || hasAcknowledgementContent"
    class="content references"
  >
    <div class="references__inner">
      <h5>
        {{ referencesTitle }}
      </h5>
      <!-- eslint-disable-next-line vue/no-v-html -->
      <div v-if="hasReferenceContent" v-html="referencesHTML" />
      <div v-if="hasAcknowledgementContent">
        <h6>
          {{ acknowledgementsTitle }}
        </h6>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="acknowledgementsHTML" />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { ArticleReferencesStoryblok } from '~/types/storyblok'

const props = defineProps<{
  content: ArticleReferencesStoryblok[]
}>()
const hasReferenceContent = computed(
  () => !!props.content?.[0]?.references?.content?.[0]?.content?.length,
)
const hasAcknowledgementContent = computed(
  () => !!props.content?.[0]?.acknowledgements?.content?.[0]?.content?.length,
)
const acknowledgementsHTML = computed(() => {
  if (!hasAcknowledgementContent.value) {
    return false
  }
  return renderRichText(props.content[0].acknowledgements)
})
const acknowledgementsTitle = computed(
  () =>
    'Content for parts of this page have been gathered from the following sources:',
)
const referencesHTML = computed(() => {
  if (!hasReferenceContent.value) {
    return false
  }
  return renderRichText(props.content[0].references)
})
const referencesTitle = computed(() => {
  return hasAcknowledgementContent.value && hasReferenceContent.value
    ? 'References and Content Acknowledgement'
    : hasAcknowledgementContent.value
      ? 'Content Acknowledgement'
      : hasReferenceContent.value
        ? 'References'
        : 'References and Content Acknowledgement'
})
</script>

<style lang="less">
section.content.references {
  margin: @gutter-xxl 0 @gutter-xl;
  padding: 0;

  .references__inner {
    background: @color-fill-pale;
    border: @1px solid @color-fill-muted;
    padding: @gutter @gutter-lg @gutter-xs;

    p {
      .font-xxs();
      .break-words();
    }

    ul,
    ol {
      .font-size(13, 18);

      li {
        p {
          a {
            background: none;
            padding: 0;
            text-decoration: underline;

            &:link,
            &:visited {
              .text-normal();
            }
          }
        }
      }
    }
  }
}

@media print {
  section.content.references {
    margin-bottom: 0;
  }
}
</style>
